import React, { useState } from "react";
import { Trans } from "@lingui/macro";
import SEO from "components/Common/SEO";
import { getPageTitle } from "lib/legacy";
import PalmToken from "img/PalmToken.svg";
import cx from "classnames";
import "./StakeV3.scss";
import { HiChevronDown, HiChevronUp, HiQuestionMarkCircle } from "react-icons/hi";
import StakeModal, { STAKE_ACTION, UNSTAKE_ACTION, PALM_TOKEN, PLP_TOKEN } from "./StakeModal";
import VestModal from "./VestModal";
import docsIcon from "../../img/docsWhite.svg";
import plpIcon from "../../img/plpIcon.png";
import ArrowRight from "../../img/ArrowRight.svg";
import ArrowConnect from "../../img/ArrowConnect.svg";
import ArrowBottom from "../../img/ArrowBottom.svg";
import tetherIcon from "../../img/tetherIcon.png";
import swapCurrency from "../../img/swapCurrency.svg";
import Tooltip from "components/Tooltip/Tooltip";

const tabsOptions = ["Stake"];

export default function StakeV3() {
  const [activeTab, setActiveTab] = useState("Stake");
  const [openPALMAccordion, setOpenPALMAccordion] = useState(true);
  const [openPLPAccordion, setOpenPLPAccordion] = useState(false);
  const [openStakeModal, setOpenStakeModal] = useState(false);
  const [openVestModal, setOpenVestModal] = useState(false);
  const [stakeModalData, setStakeModalData] = useState({ token: null, action: null });
  const [vestModalData] = useState(null);

  // const { account, library } = useWeb3React();

  const handleStakeModal = (token, action) => {
    setStakeModalData({
      token,
      action,
    });
    setOpenStakeModal(true);
  };

  const isActive = (tab) => {
    return activeTab === tab;
  };

  const [isTopHovered, setIsTopHovered] = useState(false);

  const handleTopMouseEnter = () => setIsTopHovered(true);
  const handleTopMouseLeave = () => setIsTopHovered(false);

  const [isBottomHovered, setBottomHovered] = useState(false);

  const handleBottomMouseEnter = () => setBottomHovered(true);
  const handleBottomMouseLeave = () => setBottomHovered(false);

  const handleClaimEnter = () => {
    setIsTopHovered(true);
    setBottomHovered(true);
  };
  const handleClaimLeave = () => {
    setIsTopHovered(false);
    setBottomHovered(false);
  };

  const [switchCurrency, setSwitchCurrency] = useState([false, false, false, false]);

  const handleSwitchCurrency = (index) => {
    const updatedSwitchCurrency = [...switchCurrency];
    updatedSwitchCurrency[index] = !updatedSwitchCurrency[index];
    setSwitchCurrency(updatedSwitchCurrency);
  };

  return (
    <SEO title={getPageTitle("Stake PALM")}>
      <div className="Stake-page page-layout Stake-default-container">
        <div className="Stake-container ">
          <div className="Main-content">
            <div className="Stake-card flex-column">
              <div className="Stake-card-header-wrapper">
                <span className="Stake-card-title">
                  <Trans>Staking Routes</Trans>
                </span>

                <a
                  href="https://docs.palmswap.org/"
                  target="_blank"
                  rel="noreferrer"
                  className="Stake-card-docs-button transition-effect"
                >
                  <img src={docsIcon} alt="docs" /> <span>View Documentation</span>
                </a>
              </div>
              <div className="Stake-card-apr-wrapper">
                <div className="Stake-card-apr">
                  <img src={PalmToken} alt="token" className="Stake-card-token-icon" />
                  <div className="Stake-card-apr-text">
                    <span>APR:</span>
                    <span className="Stake-card-apr-percent">25.6%</span>
                  </div>
                </div>
                <div className="Stake-card-apr">
                  <img src={plpIcon} alt="token" className="Stake-card-token-icon" />
                  <div className="Stake-card-apr-text">
                    <span>APR:</span>
                    <span className="Stake-card-apr-percent">25.6%</span>
                  </div>
                </div>
              </div>

              <div className="Stake-card-route-wrapper">
                <div
                  className={cx("Stake-card-top", { isTopHovered: isTopHovered })}
                  onMouseEnter={handleTopMouseEnter}
                  onMouseLeave={handleTopMouseLeave}
                >
                  <div className="Stake-card-currency Stake-card-currency-first transition-effect">
                    <img src={PalmToken} alt="icon" className="Stake-card-currency-icon Stake-card-palm-icon" />
                    <span>PALM</span>
                  </div>

                  <div className="Stake-card-arrow Stake-card-arrow-first transition-effect">
                    <img src={ArrowRight} alt="arrow" target="_blank" rel="noreferrer" />
                  </div>

                  <div className="Stake-card-infobox Stake-card-infobox-first transition-effect">
                    25% <Trans>of Trading fees</Trans>
                  </div>

                  <div className="Stake-card-arrow Stake-card-arrow-second transition-effect">
                    <img src={ArrowRight} alt="arrow" target="_blank" rel="noreferrer" />
                  </div>

                  <div className="Stake-card-currency Stake-card-currency-second transition-effect">
                    <img src={tetherIcon} alt="icon" className="Stake-card-currency-icon Stake-card-palm-icon" />
                    <span>USDT</span>
                  </div>

                  <div
                    className={cx("Stake-card-arrow", "Stake-card-arrow-third", "transition-effect", {
                      isBottomHovered: isBottomHovered,
                      isTopHovered: isTopHovered,
                    })}
                  >
                    <img src={ArrowConnect} alt="arrow" target="_blank" rel="noreferrer" />
                  </div>
                  <div
                    className={cx("Stake-card-arrow", "Stake-card-arrow-fourth", "transition-effect", {
                      isBottomHovered: isBottomHovered,
                      isTopHovered: isTopHovered,
                    })}
                  >
                    <img src={ArrowRight} alt="arrow" target="_blank" rel="noreferrer" />
                  </div>
                  <div
                    className={cx(
                      "Stake-card-infobox",
                      "Stake-card-infobox-second",
                      "Stake-card-infobox-claim",
                      "transition-effect",
                      {
                        isBottomHovered: isBottomHovered,
                        isTopHovered: isTopHovered,
                      }
                    )}
                    onMouseEnter={handleClaimEnter}
                    onMouseLeave={handleClaimLeave}
                  >
                    Claim
                  </div>
                </div>

                <div
                  className={cx("Stake-card-center", "transition-effect", {
                    isBottomHovered: isBottomHovered,
                  })}
                  onMouseEnter={handleBottomMouseEnter}
                  onMouseLeave={handleBottomMouseLeave}
                >
                  <div className="Stake-card-currency Stake-card-currency-third transition-effect">
                    <img src={plpIcon} alt="icon" className="Stake-card-currency-icon Stake-card-palm-icon" />
                    <span>PLP</span>
                  </div>

                  <div className="Stake-card-arrow Stake-card-arrow-fifth transition">
                    <img src={ArrowRight} alt="arrow" target="_blank" rel="noreferrer" />
                  </div>

                  <div className="Stake-card-infobox Stake-card-infobox-third transition-effect">
                    50% <Trans>of Trading fees</Trans>
                  </div>

                  <div className="Stake-card-arrow Stake-card-arrow-sixth transition-effect">
                    <img src={ArrowRight} alt="arrow" target="_blank" rel="noreferrer" />
                  </div>

                  <div className="Stake-card-currency Stake-card-currency-fourth transition-effect">
                    <img src={tetherIcon} alt="icon" className="Stake-card-currency-icon Stake-card-palm-icon" />
                    <span>USDT</span>
                  </div>
                </div>

                <div
                  className={cx("Stake-card-bottom", "transition-effect", {
                    isBottomHovered: isBottomHovered,
                  })}
                  onMouseEnter={handleBottomMouseEnter}
                  onMouseLeave={handleBottomMouseLeave}
                >
                  <div className="Stake-card-arrow Stake-card-arrow-seventh transition-effect">
                    <img src={ArrowBottom} alt="arrow" target="_blank" rel="noreferrer" />
                  </div>

                  <div className="Stake-card-bottom-infoboxes">
                    <div className="Stake-card-infobox Stake-card-infobox-fourth">
                      <Tooltip
                        handle={
                          <div className="Tooltip-handle-wrapper">
                            Mint & Burn Fees <HiQuestionMarkCircle />
                          </div>
                        }
                        position="center-bottom"
                        renderContent={() => {
                          return (
                            <div className="Stake-card-infobox-tooltip">
                              <Trans>When PLP is minted or redeemed, there is a fee.</Trans>
                            </div>
                          );
                        }}
                      ></Tooltip>
                    </div>
                    <div className="Stake-card-infobox Stake-card-infobox-fith">
                      <Tooltip
                        handle={
                          <div className="Tooltip-handle-wrapper">
                            Borrow Fees <HiQuestionMarkCircle />
                          </div>
                        }
                        position="center-bottom"
                        renderContent={() => {
                          return (
                            <div className="Stake-card-infobox-tooltip">
                              <Trans>Paid hourly by Trader.</Trans>
                            </div>
                          );
                        }}
                      ></Tooltip>
                    </div>
                    <div className="Stake-card-infobox Stake-card-infobox-sixth">
                      <Tooltip
                        handle={
                          <div className="Tooltip-handle-wrapper">
                            Liquidation Fees <HiQuestionMarkCircle />
                          </div>
                        }
                        position="center-bottom"
                        renderContent={() => {
                          return (
                            <div className="Stake-card-infobox-tooltip">
                              <Trans>Paid when a trader's position is liquidated.</Trans>
                            </div>
                          );
                        }}
                      ></Tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="Description-card">
              <div className="Decription-card-page-title-wrapper">
                <div className="Stake-card-title">
                  <Trans>Total Rewards</Trans>
                </div>
                <div className="Description-card-page-subtitle">
                  <Trans>Your Rewards Details</Trans>
                </div>
              </div>

              <div className="Description-card-bottom">
                <div className="Description-card-rewards-wrapper">
                  <div className="Description-rewards-infos">
                    <div className="Description-reward-title">
                      <Trans>PALM Staking Rewards</Trans>
                    </div>
                    <div className="Description-reward-amount">
                      <span>0 USDT</span>
                    </div>
                    <div className="Description-reward-amount-usd">~$0</div>
                  </div>
                  <div className="Description-rewards-infos">
                    <div className="Description-reward-title">
                      <Trans>PLP Staking Rewards</Trans>
                    </div>
                    <div className="Description-reward-amount">
                      <span>150.17 USDT</span>
                    </div>
                    <div className="Description-reward-amount-usd">~$150.17</div>
                  </div>
                </div>
                <div className="Description-card-claim-wrapper">
                  <div className="Description-card-claim-amount">Total Amount $150.7</div>
                  <button className="Description-card-claim-button transition-effect">Claim Rewards</button>
                </div>
              </div>
            </div>
          </div>

          <div className="Earn-tabs">
            {tabsOptions.map((opt) => (
              <div className={cx("Earn-tab", { active: isActive(opt) })} onClick={() => setActiveTab(opt)} key={opt}>
                {opt}
              </div>
            ))}
            <div className="Earn-tabs-empty"></div>
          </div>
          <div className="Tab-content flex-column">
            <div className="inactive-text Earn-tab-description">
              <Trans>Stake PALM and PLP to earn rewards.</Trans>
            </div>
            <div className="Stake-card flex-column">
              <div className="Accordion-head">
                <img src={PalmToken} alt="token" className="Token-icon" />
                <div className="PLPAccordion">
                  <div className="info-block">
                    <div className="Stake-card-title  accordion-title">
                      <Trans>PALM</Trans>
                    </div>
                    <div className="white-text currency-price">${0.023}</div>
                  </div>
                  <div className="info-block">
                    <div className="gap-container">
                      <Tooltip
                        handle={
                          <div className="Tooltip-handle-wrapper">
                            <div className="inactive-text">APR</div>
                            <HiQuestionMarkCircle className="inactive-text" />
                          </div>
                        }
                        position="center-bottom"
                        renderContent={() => {
                          return (
                            <div className="Stake-card-infobox-tooltip">
                              <Trans>
                                APRs are updated weekly on Wednesday and will depend on the fees collected for the week.
                              </Trans>
                            </div>
                          );
                        }}
                      ></Tooltip>
                    </div>
                    <div className="white-text">{0}%</div>
                  </div>
                  <div className="info-block">
                    <div className="inactive-text">
                      <Trans>Total Staked</Trans>
                    </div>
                    <div className="gap-container">
                      <div className="white-text currency-text">0 {switchCurrency[0] ? "$" : "PALM"}</div>
                      <div className="usd-tag" onClick={() => handleSwitchCurrency(0)}>
                        <img src={swapCurrency} alt="swap" />
                        {switchCurrency[0] ? "PALM" : "USD"}
                      </div>
                    </div>
                  </div>
                  <div className="info-block">
                    <div className="inactive-text">
                      <Trans>Total Supply</Trans>
                    </div>
                    <div className="gap-container">
                      <div className="white-text currency-text">0 {switchCurrency[1] ? "$" : "PALM"}</div>
                      <div className="usd-tag" onClick={() => handleSwitchCurrency(1)}>
                        <img src={swapCurrency} alt="swap" />
                        {switchCurrency[1] ? "PALM" : "USD"}
                      </div>
                    </div>
                  </div>
                  <div className="info-block">
                    <div className="gap-container">
                      <Tooltip
                        handle={
                          <div className="Tooltip-handle-wrapper">
                            <div className="inactive-text">Total Earned</div>
                            <HiQuestionMarkCircle className="inactive-text" />
                          </div>
                        }
                        position="center-bottom"
                        renderContent={() => {
                          return (
                            <div className="Stake-card-infobox-tooltip">
                              <Trans>Total earnings of all users together</Trans>
                            </div>
                          );
                        }}
                      ></Tooltip>
                    </div>
                    <div className="white-text">${0}</div>
                  </div>
                </div>
                <div className="Chevron-icon-container" onClick={() => setOpenPALMAccordion(!openPALMAccordion)}>
                  {openPALMAccordion ? <HiChevronUp /> : <HiChevronDown />}
                </div>
              </div>

              <div
                className={cx("Accordion-body", {
                  openPALMAccordion: openPALMAccordion,
                })}
              >
                <div className="Card-divider"></div>
                <div className="flex-row">
                  <div className="info-block">
                    <div className="inactive-text">
                      <Trans>Wallet</Trans>
                    </div>
                    <div className="white-text-big">{0} PALM</div>
                    <div className="inactive-text-small">~${0}</div>
                    <a
                      className="Stake-button Stake-button-white"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://pancakeswap.finance/swap?outputCurrency=0x29745314B4D294B7C77cDB411B8AAa95923aae38"
                    >
                      <Trans>Buy PALM</Trans>
                    </a>
                  </div>
                  <div className="info-block">
                    <div className="inactive-text">
                      <Trans>PALM Staked</Trans>
                    </div>
                    <div className="white-text-big">{0} PALM</div>
                    <div className="inactive-text-small">~${0}</div>
                    <div className="gap-container">
                      <div
                        className="Stake-button Stake-button-white"
                        onClick={() => {
                          handleStakeModal(PALM_TOKEN, STAKE_ACTION);
                        }}
                      >
                        <Trans>+ Stake</Trans>
                      </div>
                      <div
                        className="Stake-button Stake-button-white round-button"
                        onClick={() => {
                          handleStakeModal(PALM_TOKEN, UNSTAKE_ACTION);
                        }}
                      >
                        -
                      </div>
                    </div>
                  </div>
                  <div className="info-block">
                    <div className="inactive-text">
                      <Trans>Rewards</Trans>
                    </div>
                    <div className="white-text-big">{0} USDT</div>
                    <div className="inactive-text-small">~${0}</div>
                  </div>
                  <div className="info-block">
                    <div className="inactive-text">
                      <Trans>Total Rewards Earned</Trans>
                    </div>
                    <div className="white-text-big">{0} USDT</div>
                    <div className="inactive-text-small">~${0}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="Stake-card flex-column">
              <div className="Accordion-head">
                <img src={plpIcon} alt="token" className="Token-icon" />
                <div className=" PLPAccordion">
                  <div className="info-block accordion-title">
                    <div className="Stake-card-title">
                      <Trans>PLP</Trans>
                    </div>
                    <div className="white-text currency-price">${0.023}</div>
                  </div>
                  <div className="info-block">
                    <div className="gap-container">
                      <Tooltip
                        handle={
                          <div className="Tooltip-handle-wrapper">
                            <div className="inactive-text">APR</div>
                            <HiQuestionMarkCircle className="inactive-text" />
                          </div>
                        }
                        position="center-bottom"
                        renderContent={() => {
                          return (
                            <div className="Stake-card-infobox-tooltip">
                              <Trans>
                                APRs are updated weekly on Wednesday and will depend on the fees collected for the week.
                              </Trans>
                            </div>
                          );
                        }}
                      ></Tooltip>
                    </div>
                    <div className="white-text">{0}%</div>
                  </div>
                  <div className="info-block">
                    <div className="inactive-text">
                      <Trans>Total Staked</Trans>
                    </div>
                    <div className="gap-container">
                      <div className="white-text currency-text">0 {switchCurrency[2] ? "$" : "PLP"}</div>
                      <div className="usd-tag" onClick={() => handleSwitchCurrency(2)}>
                        <img src={swapCurrency} alt="swap" />
                        {switchCurrency[2] ? "PLP" : "USD"}
                      </div>
                    </div>
                  </div>
                  <div className="info-block">
                    <div className="inactive-text">
                      <Trans>Total Supply</Trans>
                    </div>
                    <div className="gap-container">
                      <div className="white-text currency-text">0 {switchCurrency[3] ? "$" : "PLP"}</div>
                      <div className="usd-tag" onClick={() => handleSwitchCurrency(3)}>
                        <img src={swapCurrency} alt="swap" />
                        {switchCurrency[3] ? "PLP" : "USD"}
                      </div>
                    </div>
                  </div>
                  <div className="info-block">
                    <div className="gap-container">
                      <Tooltip
                        handle={
                          <div className="Tooltip-handle-wrapper">
                            <div className="inactive-text">Total Earned</div>
                            <HiQuestionMarkCircle className="inactive-text" />
                          </div>
                        }
                        position="center-bottom"
                        renderContent={() => {
                          return (
                            <div className="Stake-card-infobox-tooltip">
                              <Trans>Total earnings of all users together</Trans>
                            </div>
                          );
                        }}
                      ></Tooltip>
                    </div>
                    <div className="white-text">${0}</div>
                  </div>
                </div>
                <div className="Chevron-icon-container" onClick={() => setOpenPLPAccordion(!openPLPAccordion)}>
                  {openPLPAccordion ? <HiChevronUp /> : <HiChevronDown />}
                </div>
              </div>

              <div
                className={cx("Accordion-body", {
                  openPLPAccordion: openPLPAccordion,
                })}
              >
                <div className="Card-divider"></div>
                <div className="flex-row">
                  <div className="info-block">
                    <div className="inactive-text">
                      <Trans>PLP Staked</Trans>
                    </div>
                    <div className="white-text-big">{0} PLP</div>
                    <div className="inactive-text-small">~${0}</div>
                    <div className="gap-container">
                      <div
                        className="Stake-button Stake-button-white"
                        onClick={() => {
                          handleStakeModal(PLP_TOKEN, STAKE_ACTION);
                        }}
                      >
                        <Trans>+ Stake</Trans>
                      </div>
                      <div
                        className="Stake-button Stake-button-white round-button"
                        onClick={() => {
                          handleStakeModal(PLP_TOKEN, UNSTAKE_ACTION);
                        }}
                      >
                        -
                      </div>
                    </div>
                  </div>
                  <div className="info-block">
                    <div className="inactive-text">
                      <Trans>Rewards</Trans>
                    </div>
                    <div className="white-text-big">{0} USDT</div>
                    <div className="inactive-text-small">~${0}</div>
                  </div>
                  <div className="info-block">
                    <div className="inactive-text">
                      <Trans>Total Rewards Earned</Trans>
                    </div>
                    <div className="white-text-big">{0} USDT</div>
                    <div className="inactive-text-small">~${0}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <StakeModal open={openStakeModal} setOpen={setOpenStakeModal} stakeModalData={stakeModalData} />
      <VestModal open={openVestModal} setOpen={setOpenVestModal} token={vestModalData} />
    </SEO>
  );
}
